module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.c66252fa.png";